import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../../authentication/service/auth.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  constructor(private auth: AuthService) { }

  ngOnInit() {
  }

  private checkAuthentication() {
    Observable.fromPromise(this.auth.isAuthenticated())
      .map(isAuthed => {
        return isAuthed;
      });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/dashboard/dashboard.component.ts